class InfoTooltip extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (e) => {
      const summary = e.target.closest("summary");
      if (summary !== this.summary) return;

      e.preventDefault();
      this.details.open ? this.close() : this.open();
    });

    this.addEventListener("mouseenter", (e) => {
      this.open();
    });

    this.addEventListener("mouseleave", (e) => {
      clearTimeout(this.closeTimeout);

      this.closeTimeout = window.setTimeout(() => this.close(), 1000);
    });

    this.addEventListener("focusout", (e) => {
      if (this.contains(e.relatedTarget)) return;
      this.close();
    });

    // This doesn't work with preact so just set alignment statically.
    // const handleResize = () => {
    //   const { x } = this.getBoundingClientRect();
    //   this.dataset.alignment = x / window.innerWidth > 0.5 ? "right" : "left";
    // };

    // handleResize();

    // this.addEventListener("resize", handleResize);
  }

  connectedCallback() {}

  disconnectedCallback() {}

  open() {
    clearTimeout(this.closeTimeout);

    if (this.details.open || this.transitioning) return;
    this.transitioning = true;

    this.removeEventListener("transitionend", this.handleTransitionEnd);

    this.handleTransitionEnd = () => {
      this.removeEventListener("transitionend", this.handleTransitionEnd);
      this.transitioning = false;
    };

    this.addEventListener("transitionend", this.handleTransitionEnd);

    this.details.open = true;

    window.requestAnimationFrame(() => {
      this.details.classList.add("open");
    });
  }

  close() {
    if (!this.details.open || this.transitioning) return;
    this.transitioning = true;
    if (this.content) {
      this.removeEventListener("transitionend", this.handleTransitionEnd);

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.details.open = false;
        this.transitioning = false;
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      this.details.classList.remove("open");
    } else {
      this.details.classList.remove("open");
      this.details.open = false;
      this.transitioning = false;
    }
  }

  get summary() {
    return this.querySelector("summary");
  }

  get details() {
    return this.querySelector("details");
  }

  get content() {
    return this.querySelector("[data-content]");
  }
}

if (!customElements.get("info-tooltip")) {
  customElements.define("info-tooltip", InfoTooltip);
}
